module.exports = __webpack_public_path__ + "img/653c594.png";